<template lang="pug">
 div
   .text-sm.text-secondary Propiedades
     b-table.card-table.scrollable-area.max-h-250(responsive, show-empty, small, striped,
       empty-text="No hay propiedades para mostrar"
       :items="userProperties",
       :fields="fields",
     )
       template(v-slot:cell(title)="{ item }")
         span {{ item.property.title }}
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'UserProperties',
  data() {
    return {
      userProperties: [],
      fields: [
        { key: 'title', label: 'Propiedad'},
        { key: 'value', label: 'Valor'}
      ],
    }
  },
  props: ['userId'],
  methods: {
    ...mapActions([
      'user/properties',
    ]),
    getProperties() {
      this['user/properties']({
        user_id: this.userId,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.userProperties = res.resource.slice()
        }
      })
    },
  },
  mounted() {
    this.getProperties()
  }
}
</script>

<style scoped>

</style>